import {UnitPaymentCategory} from '../unit-payment-category.enum';
import {RecipientCreateDto} from '../recipient/recipient-create-dto.model';
import {UnitPaymentPurpose} from '../unit-payment-purpose.enum';
import {PaymentType} from '../../../../../enums/payment-type.enum';
import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';

export class PaymentCreateDto {
  public category: UnitPaymentCategory;
  public purpose: UnitPaymentPurpose;
  public amount: number;
  public description: string;
  public internalNotes: string;
  public referenceNumber: string;
  public sourceUnitBankAccountId: number;
  public idempotencyKey: string;
  public recipientId: number | undefined;
  public recipient: RecipientCreateDto | undefined;
  public paymentType: PaymentType;
  public otp: string;
  public destinationUnitBankAccountId: number | undefined;
}
